import React, { Component } from "react";
import moment from "moment";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { PurchaseOrderPartStates } from "./types/PurchaseOrderPartTypes";
import { purchaseOrderPartApiService } from "../../services/bengkel/PurchaseOrderPartApiService";
import SelectDealer from "../../components/dealer/select-dealer.component";
import SelectOrganization from "../../components/organization/SelectOrganization.component";
import withAuth from "../../hoc/withAuth";
import { Button, Form, Input, Checkbox, DatePicker, Col, Row, Modal } from "antd";
import type { DatePickerProps } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { SaveOutlined, ReloadOutlined } from "@ant-design/icons";
import { HotTable } from "@handsontable/react";
import "./PurchaseOrderPart.css";

const { TextArea } = Input;

export interface PurchaseOrderPartProps {}

class PurchaseOrderPart extends Component<PurchaseOrderPartProps & any, PurchaseOrderPartStates> {
  private readonly initState!: PurchaseOrderPartStates;
  private readonly id: string;
  private readonly hotSettings: any;
  private readonly hotTableComponent: React.RefObject<any>;

  constructor(props: (PurchaseOrderPartProps & any) | any) {
    super(props);

    this.initState = {
      user: "",
      processing: false,
      processingFetchTableData: true,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dataConfig: [],
      pageSize: 500,
      modalAddWarehouse: false,
      addProcessing: false,
      checkboxSame: true,

      WorkshopCode: "",
      WorkshopName: "",
      WorkshopDetail: "",
      EventDate: moment().format("YYYY-MM-DD"),
      PartList: [],

      VendorCode: "",
      VendorName: "",
      VendorAddress: "",
      VendorPhone: "",
      VendorEmail: "",

      WarehouseName: "",
      WarehouseAddress: "",
      WarehousePhone: "",
      WarehouseEmail: "",

      DeliveryDate: moment().format("YYYY-MM-DD"),
      ShippingMethod: "",
      ShippingTerms: "",
      Notes: "",
    };
    this.state = { ...this.initState };

    this.id = "hot";

    this.hotSettings = {
      rowHeaders: true,
      colWidths: 150,
      width: "100%",
      height: 400,
      colHeaders: ["PART CODE", "UOM", "QTY", "PRICE"],
      columns: [
        { data: "part_code", type: "text", width: 200 },
        { data: "part_uom", type: "text" },
        { data: "quantity", type: "text" },
        { data: "price", type: "text" },
      ],
    };
    this.hotTableComponent = React.createRef();
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });
  };

  async componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      const user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      await this.promisedSetState({
        user: user,
      });

      // console.log(this.state.user);
    }
  }

  onClickSave = async () => {
    const dataTable = this.hotTableComponent.current.hotInstance.getData();
    const parts = [];
    for (const row of dataTable) {
      const partCode = row[0]?.trim();
      const partUom = row[1]?.trim()?.toLowerCase();
      const partQuantity = row[2]?.trim();
      const partPrice = row[3]?.trim();

      // let totalCost = row[6];
      if (partCode && partUom && partQuantity && partPrice) {
        parts.push({
          part_code: partCode,
          part_name: "",
          part_type: "",
          part_uom: partUom,
          price: Number(partPrice),
          quantity: Number(partQuantity),
          amount: Number(0),
        });
      }
    }

    if (this.state.WorkshopCode === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Workshop Code]",
      });
      return false;
    }
    if (this.state.EventDate === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Event Date]",
      });
      return false;
    }
    if (this.state.VendorName === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Vendor Name]",
      });
      return false;
    }
    if (this.state.WarehouseName === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Warehouse Name]",
      });
      return false;
    }
    if (this.state.DeliveryDate === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Delivery Date]",
      });
      return false;
    }

    const input = {
      workshop_code: this.state.WorkshopCode,
      workshop_name: this.state.WorkshopName,
      event_created: this.state.EventDate,

      vendor_code: this.state.VendorCode,
      vendor_name: this.state.VendorName,
      vendor_detail: {
        address: this.state.VendorAddress,
        email: this.state.VendorEmail,
        phone: this.state.VendorPhone,
      },

      shipping_detail: {
        warehouse_name: this.state.WarehouseName,
        workshop_name: this.state.WorkshopName,
        address: this.state.WarehouseAddress,
        email: this.state.WarehouseEmail,
        phone: this.state.WarehousePhone,
        delivery_date: this.state.DeliveryDate,
        shipping_method: this.state.ShippingMethod,
        shipping_terms: this.state.ShippingTerms,
      },

      parts: parts,

      taxrate: 0,
      taxratetype: "FLAT",
      total_transaction: 0,
      total_discount: 0,
      total_shipping_fee: 0,

      notes: this.state.Notes,
      created_by: this.state.user,
      platform: "app-web",
      source: "otodis-purchase-order-part",
    };

    if (parts?.length < 1) {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap",
      });
      await this.promisedSetState({
        processing: false,
      });
      return;
    } else {
      await this.promisedSetState({
        processing: true,
      });

      try {
        // console.log(input);

        await purchaseOrderPartApiService.create(input).then((response) => {
          this.setState({
            processing: false,
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "purchase-order.pdf");
          document.body.appendChild(link);
          link.click();
        });
      } catch (e) {
        Modal.error({
          title: "Proses Gagal",
          content: "Server Menolak Inputan Anda :" + e,
        });
        await this.promisedSetState({
          processing: false,
        });
      }
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  disabledDate = (current: any) => {
    // Can not select days before today
    let oneDay = 1000 * 60 * 60 * 24;
    let dateNow = Date.now();
    let limitDate = dateNow - oneDay;
    return current && current.valueOf() < limitDate;
  };

  onWorkshopChange = (v: string, i: any) => {
    console.log(i);

    this.setState({
      WorkshopCode: v,
      WorkshopName: i.children,
      WorkshopDetail: i.add_text,
    });
  };

  onCheckboxChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked === true && this.state.WorkshopDetail !== "") {
      const list = this.state.WorkshopDetail.split("#");
      this.setState({
        WarehouseAddress: list[0],
        WarehousePhone: list[1],
        WarehouseEmail: list[2],
      });
    }
  };

  onDatePoChange: DatePickerProps["onChange"] = (date, dateString) => {
    this.setState({
      EventDate: dateString,
    });
    console.log(this.state.EventDate);
  };

  onDeliveryDateChange: DatePickerProps["onChange"] = (date, dateString) => {
    this.setState({
      DeliveryDate: dateString,
    });
  };

  onClickRefreshTable = () => {
    let emptyData = [];
    this.hotTableComponent.current.hotInstance.loadData([]);
    for (let i = 0; i < 15; i++) {
      emptyData.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
    }
    this.hotTableComponent.current.hotInstance.loadData(emptyData);
    console.log("countRows", this.hotTableComponent.current.hotInstance.countRows());

    this.setState({
      processing: false,
    });
  };

  onOrganizationChange = async (v: any, i: any) => {
    await this.setState({
      VendorCode: v,
      VendorName: i.children,
      VendorAddress: i.da,
      VendorPhone: i.dp,
      VendorEmail: i.de,
    });
  };

  onStringFieldChange = <
    T extends keyof Pick<
      any,
      | "VendorName"
      | "VendorName"
      | "VendorAddress"
      | "VendorPhone"
      | "VendorEmail"
      | "WarehouseName"
      | "WarehouseAddress"
      | "WarehousePhone"
      | "WarehouseEmail"
      | "DeliveryDate"
      | "ShippingMethod"
      | "ShippingTerms"
      | "Notes"
    >
  >(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "VendorName":
        currentState.VendorName = value;
        break;
      case "VendorAddress":
        currentState.VendorAddress = value;
        break;
      case "VendorPhone":
        currentState.VendorPhone = value;
        break;
      case "VendorEmail":
        currentState.VendorEmail = value;
        break;
      case "WarehouseName":
        currentState.WarehouseName = value;
        break;
      case "WarehouseAddress":
        currentState.WarehouseAddress = value;
        break;
      case "WarehousePhone":
        currentState.WarehousePhone = value;
        break;
      case "WarehouseEmail":
        currentState.WarehouseEmail = value;
        break;
      case "DeliveryDate":
        currentState.DeliveryDate = value;
        break;
      case "ShippingMethod":
        currentState.ShippingMethod = value;
        break;
      case "ShippingTerms":
        currentState.ShippingTerms = value;
        break;
      case "Notes":
        currentState.Notes = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  render() {
    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const buttonItemLayout = { wrapperCol: { span: 18, offset: 6 } };
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Purchase Order Part`}
          defaultSelectedKeys={["m-purchase-order-part"]}
          defaultOpenKeys={["sm-bengkel"]}
        >
          <Form {...layout} layout="horizontal" className="custom-form">
            <Row className={`pad-10`}>
              <Col span={12} className={`pad-10`}>
                <SelectDealer label="Nama Bengkel" value={this.state.WorkshopCode} onChangeValue={this.onWorkshopChange}></SelectDealer>
                <Form.Item label="Tanggal PO">
                  <DatePicker onChange={this.onDatePoChange} picker="date" disabledDate={this.disabledDate} defaultValue={moment()} />
                </Form.Item>

                <strong>Vendor Data</strong>
                <hr />
                <SelectOrganization label="Vendor" value={this.state.VendorCode} onChangeValue={this.onOrganizationChange} />
                {/* <Form.Item label="Nama Vendor">
                                    <Input value={this.state.VendorName} placeholder="Nama Vendor" onChange={event => this.onStringFieldChange("VendorName", event.target.value)} />
                                </Form.Item> */}
                <Form.Item label="Alamat">
                  <TextArea
                    value={this.state.VendorAddress}
                    placeholder="Alamat"
                    onChange={(event) => this.onStringFieldChange("VendorAddress", event.target.value)}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  ></TextArea>
                </Form.Item>
                <Form.Item label="Telepon">
                  <Input value={this.state.VendorPhone} placeholder="Telepon" onChange={(event) => this.onStringFieldChange("VendorPhone", event.target.value)} />
                </Form.Item>
                <Form.Item label="Email">
                  <Input value={this.state.VendorEmail} placeholder="Email" onChange={(event) => this.onStringFieldChange("VendorEmail", event.target.value)} />
                </Form.Item>

                <div style={{ paddingTop: "80px" }}>
                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.processing} onClick={this.onClickSave} style={{ marginRight: "5px" }}>
                    Simpan Data
                  </Button>
                  <Button
                    onClick={this.onClickRefreshTable}
                    type="primary"
                    icon={<ReloadOutlined />}
                    style={{ background: "#ca2e2e", borderColor: "#ca2e2e", marginLeft: "5px" }}
                    loading={this.state.processing}
                  >
                    Refresh Table
                  </Button>
                  <br />
                  <br />

                  <div>
                    <HotTable ref={this.hotTableComponent} id={this.id} settings={this.hotSettings} />
                  </div>
                </div>
              </Col>

              <Col span={12} className={`pad-10`}>
                <strong>Shipping Detail</strong>
                <hr />
                <Form.Item label="Nama Gudang">
                  <Input value={this.state.WarehouseName} placeholder="Nama Gudang" onChange={(event) => this.onStringFieldChange("WarehouseName", event.target.value)} />
                </Form.Item>
                <Form.Item {...buttonItemLayout}>
                  <Checkbox value={this.state.checkboxSame} onChange={this.onCheckboxChange}>
                    {" "}
                    <b>
                      <i>Sama seperti bengkel</i>
                    </b>
                  </Checkbox>
                </Form.Item>
                <Form.Item label="Alamat">
                  <TextArea
                    value={this.state.WarehouseAddress}
                    placeholder="Alamat"
                    onChange={(event) => this.onStringFieldChange("WarehouseAddress", event.target.value)}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  ></TextArea>
                </Form.Item>
                <Form.Item label="Telepon">
                  <Input value={this.state.WarehousePhone} placeholder="Telepon" onChange={(event) => this.onStringFieldChange("WarehousePhone", event.target.value)} />
                </Form.Item>
                <Form.Item label="Email">
                  <Input value={this.state.WarehouseEmail} placeholder="Email" onChange={(event) => this.onStringFieldChange("WarehouseEmail", event.target.value)} />
                </Form.Item>
                <Form.Item label="Tanggal Pengiriman">
                  <DatePicker onChange={this.onDeliveryDateChange} picker="date" disabledDate={this.disabledDate} defaultValue={moment()} />
                </Form.Item>
                <Form.Item label="Metode Pengiriman">
                  <Input value={this.state.ShippingMethod} placeholder="Metode Pengiriman" onChange={(event) => this.onStringFieldChange("ShippingMethod", event.target.value)} />
                </Form.Item>
                <Form.Item label="Ketentuan Pengiriman">
                  <TextArea
                    value={this.state.ShippingTerms}
                    placeholder="Ketentuan Pengiriman"
                    onChange={(event) => this.onStringFieldChange("ShippingTerms", event.target.value)}
                    autoSize={{ minRows: 5, maxRows: 5 }}
                  ></TextArea>
                </Form.Item>
                <Form.Item label="Catatan">
                  <TextArea value={this.state.Notes} placeholder="Catatan" onChange={(event) => this.onStringFieldChange("Notes", event.target.value)} autoSize={{ minRows: 5, maxRows: 5 }}></TextArea>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(PurchaseOrderPart), 43);
